import React, {Component} from 'react';

class ErrorBoundry extends Component {
    constructor(props) { //allow acess to props
        super();
        this.state = {
            hasError: false,
        }
    }

    //try catch block in javascript
    componentDidCatch(error,info){
        this.setState({hasError:true})
    }

    render() {
        if (this.state.hasError) {
            return <h1>Opps. that is not good</h1>
        } else {
            return this.props.children
        }
    }
}

export default ErrorBoundry;